"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data = {
    empty: {
        titleText: '暂无数据'
    },
    modal: {
        okText: '确定',
        cancelText: '取消',
        confirmText: '确定'
    },
    form: {
        submitText: '确定',
        cancelText: '取消'
    },
    select: {
        emptyText: '没有找到相关结果'
    },
    checkbox: {
        checkAllText: '全选'
    },
    textInput: {
        clearText: '清除输入'
    },
    table: {
        filter: {
            okText: '确定',
            resetText: '重置'
        },
        emptyText: '暂无数据'
    },
    datePicker: {
        rangeDateText: ['开始日期', '结束日期'],
        rangeTimeText: ['开始时间', '结束时间'],
        dateText: '请选择日期',
        timeText: '请选择时间',
        locale: 'zh_CN',
        today: '今天',
        now: '此刻',
        backToToday: '返回今天',
        ok: '确定',
        timeSelect: '选择时间',
        dateSelect: '选择日期',
        weekSelect: '选择周',
        clear: '清除',
        month: '月',
        year: '年',
        previousMonth: '上个月 (翻页上键)',
        nextMonth: '下个月 (翻页下键)',
        monthSelect: '选择月份',
        yearSelect: '选择年份',
        decadeSelect: '选择年代',
        yearFormat: 'YYYY年',
        dayFormat: 'D日',
        dateFormat: 'YYYY年M月D日',
        dateTimeFormat: 'YYYY年M月D日 HH时mm分ss秒',
        previousYear: '上一年 (Control键加左方向键)',
        nextYear: '下一年 (Control键加右方向键)',
        previousDecade: '上一年代',
        nextDecade: '下一年代',
        previousCentury: '上一世纪',
        nextCentury: '下一世纪'
    }
};
exports.default = data;
//# sourceMappingURL=cn.js.map